import axios from "axios";
const BASE_URL = 'https://srv361229377.host.ultaserver.net'
// 
// 'http://localhost:8000'
//''https://8fsb9mjjwb.us-east-1.awsapprunner.com/'
// 'https://the-cooperative-backend-1.onrender.com'
    // 'https://the-cooperative-backend-1.onrender.com'
    // 'https://the-cooperative-backend-9s9u.onrender.com'
    // 'https://the-cooperative-backend.onrender.com'
    // 'https://the-cooperative-backend-e3a8.onrender.com'
    // 'https://hsdfjgsugerugfksgxfsbjcfsknxkjwsrcrgiijghernuih.online'

export const api = axios.create({
    baseURL: BASE_URL
});

// export const apiPrivate = axios.create({
//     baseURL: BASE_URL,
//     headers: {'Content-Type': 'application/json'},
//     withCredentials: true
// });
 


 

// const [transactions, setTransactions] = useState([]);
// const [formData, setFormData] = useState({
// });


// const fetchTransactions = async () => {
// const response = await api.get('/transactions/');
// setTransactions(response.data)
// };

// useEffect(() => {
// fetchTransactions();
// }, []);


// const handleInputChange = (event) => {
// const value = event.target.value === 'checkbox' ? event.target.checked : event.target.value;
// setFormData({
//   ...formData,
//   [event.target.name]: value,
// });
// };

// const handleFormSubmit = async (event) => {
// event.preventDefault();
// await api.post('/transactions/', formData);
// fetchTransactions();
// setFormData({
//   amount: '',
//   category: '',
//   description: '',
//   is_income: false,
//   date: ''
// });
// };
